// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:40em){.additional-analysis__end p,.additional-analysis__start p{font-size:1.25em}}", ""]);
// Exports
module.exports = exports;
